import Util from '@/lib/util'
export default [
    {
        title:Util.L('Code'),
        key:'toReqCode',
        width:150
    },
   
    {
        title:Util.L('SrcWarehouse'),
        key:'srcWarehouseDisplayName'
    },
    {
        title:Util.L('SoStatus'),
        key:'outStatusName'
    },
    {
        title:Util.L('DstWarehouse'),
        key:'dstWarehouseDisplayName'
    },
    {
        title:Util.L('PoStatus'),
        key:'inStatusName'
    },
    {
        title:Util.L('AssetType'),
        key:'assetTypeName'
    },
    {
        title:Util.L('ConditionType'),
        key:'conditionTypeName'
    },
    {
        title:Util.L('CreationTime'),
        key:'transferDate',
        render:(h:any,params:any)=>{
            return h("span", Util.toViewDateString(params.row.transferDate));
        }
    }
]